module.exports = require("./../../_gen/starling/utils/ScaleMode");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/utils/ScaleMode.js
// module id = 253
// module chunks = 0